import type { UseQueryResult } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
// src/hooks/useGetDomains.ts
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

type Subdomain = {
  id: number;
  domainId: number;
  name: string;
  description: string;
  orderNumber: number;
  numQuestions: number;
  numRandomExamQuestions: number;
};

type Domain = {
  id: number;
  productId: number;
  name: string;
  numQuestions: number;
  subdomains: Subdomain[];
};

/**
 * Hook to get domains (with subdomains) for a product.
 */
export function useGetMarketingDomains(
  productId: number | null | undefined,
): UseQueryResult<Domain[], AxiosError> {
  return useQuery<Domain[], AxiosError>({
    queryKey: ['domain-product-map', productId],
    queryFn: async () => {
      const res = await axios.get(`/api/marketing/domains-by-product?productId=${productId}`);
      return res.data;
    },
    retry: false,
  });
}
